__turbopack_context__.v({
  "breadcrumbs": "RepairDetailsPageChrome-module-scss-module__H-brDa__breadcrumbs",
  "hero": "RepairDetailsPageChrome-module-scss-module__H-brDa__hero",
  "heroTop": "RepairDetailsPageChrome-module-scss-module__H-brDa__heroTop",
  "page": "RepairDetailsPageChrome-module-scss-module__H-brDa__page",
});
